<template>
<div class="row">
  <div class="flex lg3 md12 xs12">
    <va-card class="tamanho_avisoa">
    <p class="text-center display-3">Disciplinas</p>
         <hr>
      <div v-for="(lista_disciplinas,index) in getAllMateriasCurso" :key="index"  class="tamanho_avisos display-5 my-2 text-center">
        <va-button type="submit" @click="mudar_disciplina(lista_disciplinas)"  color="info"  class="tamanho_avisos display-5 my-2 text-center">{{lista_disciplinas.nome_disciplina}}</va-button>
      </div>
  </va-card>
  </div>
  <div class="flex lg4 md12 xs12 ">
        <va-card class="tamanho_avisoa">
        <div>
          
          <p class="display-3 text-center">Bienvenido</p>
        </div>
        <hr>

          <va-card class="tamanho_avisos display-5 my-2 text-center"  >
               <p display-3 text-center>{{disciplina.nome}}</p>
            </va-card>
      
        </va-card>
      
       
  </div>
       <div class="flex lg5 md12 xs12 tamanho_avisoa">
      

         <va-card class="scroll tamanho_avisoa">
            <div>
               <p class="display-3 text-center">Avisos</p>
            </div>
             <hr>

             <chatrespostas />
                   
         </va-card> 
      
       
  </div>
  <!-- inicio calendario -->
   <div class=" flex row">
      <div class="flex md12 xs12 lg7" >
    
        <va-card  > <!--  class="my-2" -->
            <div>
              
              <p  class="display-3 text-center">Calendario</p>
            </div>
            <hr>

            <va-data-table
            :fields="getlista"
            :data="getCalendarioMateria"
            hoverable
            no-pagination
            > 
                <template slot="marker" slot-scope="props">
                  <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
                </template>
                
            </va-data-table>
<br>
<br>
<br>
<br>
            <form @submit.prevent="addCalendario()" >
              <div class="row">
                 <div class="flex lg4 md12 sm12 xs12">
                  <va-input
                  :label="$t('forms.selects.simple')"
                    v-model="calendario.mensagem"
                    placeholder="Mensagem"
                  />
                </div>

                <div class="flex lg4 md12 sm12 xs12">
                  <va-input
                  :label="'Fecha inicio'"
                    v-model="calendario.data_inicio"
                    type="date"
                    placeholder="Fecha Encerramento"
                  />
                </div>
                <div class="flex lg4 md12 sm12 xs12">
                  <va-input
                  :label="'Fecha Finalización'"
                    v-model="calendario.data_termino"
                    type="date"
                    placeholder="Fecha Encerramento"
                  />
                </div>
                <div class="flex lg12 md12 sm12 xs12 text-center">
                    <va-button class="text-right"  color="dark"> {{ $t('Geral.Salvar') }}</va-button>
                </div>
              </div>

          </form>
              
        </va-card>
          
       
        
      </div>
     
  </div> 
  <!-- fim calendario -->



</div>


</template>

<script>
import chatrespostas from './chatRespostas'
export default {
  components: { chatrespostas },
  
    data () {
      return {
        calendario:{
          mensagem:'',
          data_inicio:'',
          data_termino:'',
          oferta_data_disciplina_id:''

        },

         disciplina: {
            id:'',
            nome:''
          },
         videos: {
            id: this.$store.state.datamateria.setmateria.id,
            tipo_arquivo_id: 1,
          },
          slides: {
            id: this.$store.state.datamateria.setmateria.id,
            tipo_arquivo_id: 2,
          },
          audios: {
            id: this.$store.state.datamateria.setmateria.id,
            tipo_arquivo_id: 3,
          },
          extras: {
            id: this.$store.state.datamateria.setmateria.id,
            tipo_arquivo_id: 5,
          },
       
      }
  },
  created(){
      this.all();
    },
  computed: {
    
    getAllMateriasCurso(){
        return this.$store.state.datamateria.datamateria    
      },
    allArquviosVideos (){ return this.$store.state.arquivos.allArquivosVideos },
    allArquviosSlides (){ return this.$store.state.arquivos.allArquivosSlides   },
    allArquviosAudios (){ return this.$store.state.arquivos.allArquivosAudios   },
    allArquviosExtras (){ return this.$store.state.arquivos.allArquivosExtras   },
    
    getCalendarioMateria(){ return this.$store.state.mensagens.setCalendarioAcademico  }, 
    getlista () {
        return [{
          name: '__slot:marker',
          width: '30px',
          dataClass: 'text-center',
        }, {
          name: 'mensagem',
          title: this.$t('tables.headings.name'),
        }, {
          name: 'data_inicio',
        //  dataClass: 'text-center',
          title: 'Inicio',
         
        }, {
          name: 'data_termino',
         // dataClass: 'text-center',
          title: 'Cierre',
         
        }]
    },
    
  },
  methods: {
   async all() {

     await  this.$store.dispatch('allDatamateria',this.$store.state.gradecurricular.dados_gradecurricular.id)
     this.disciplina.nome =  this.$store.state.datamateria.setmateria.nome_disciplina
     this.disciplina.id =  this.$store.state.datamateria.setmateria.id
     
     this.$store.dispatch('allAvisosDisciplina',this.$store.state.datamateria.setmateria.id )
     this.$store.dispatch('allCalendariaAcademico',this.$store.state.datamateria.setmateria.id)
    },
   async mudar_disciplina(value){
       
    await this.$store.dispatch('setMateria',value)
      
    this.all();

    },
   async addCalendario(){
      console.log(this.calendario)
      this.calendario.oferta_data_disciplina_id = this.disciplina.id
      await this.$store.dispatch('addCalenarioMateria',this.calendario)
      
      this.calendario = {
          mensagem:'',
          data_inicio:'',
          data_termino:'',
       

        }
        this.all()

    },
    
    download_arquivo(value) {
    
      this.$store.dispatch('downloadArquivo',value)
      
    },
    
  }
}
</script>

<style scoped>

.tamanho {
  width: 100%;
  
}
.tamanho_avisos {
  width: 100%;
}
.tamanho_avisoa {
 min-height: 300px;
 max-height: 300px;
}
.scroll{
  overflow-y: scroll;
  max-height: 480px;

}

</style>